// extracted by mini-css-extract-plugin
module.exports = {"msg":"freeze-ewallet-modal_msg_HVRVz"};